import { render } from "./AgreementPage.vue?vue&type=template&id=25dab8e8"
import script from "./AgreementPage.vue?vue&type=script&lang=js"
export * from "./AgreementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__